import { useState, useEffect } from 'react';
import { isFavoriteProperty, toggleFavorite } from './favoriteUtils';

// Custom hook for managing favorite state
export const useFavorite = (propertyId) => {
  const [isFavorite, setIsFavorite] = useState(() => isFavoriteProperty(propertyId));

  // Sync favorite state when propertyId changes
  useEffect(() => {
    setIsFavorite(isFavoriteProperty(propertyId));
  }, [propertyId]);

  // Handle favorite toggle
  const handleFavoriteToggle = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const newFavoriteState = toggleFavorite(propertyId);
    setIsFavorite(newFavoriteState);
    return newFavoriteState;
  };

  return {
    isFavorite,
    handleFavoriteToggle
  };
};